var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},_vm._l((_vm.menuList),function(prod,idx){return _c('v-flex',{key:prod.id,attrs:{"sm6":"","md3":"","lg3":""}},[_c('app-menu-item',{key:idx,attrs:{"item":prod,"uid":_vm.user,"name":prod.menuName}})],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-471761d9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Store.vue
// module id = nKO2
// module chunks = 1